import React,{useEffect} from 'react';
import { Divider, Row, Col} from "antd";
import Talk from 'talkjs';
import NetlifyContactForm from './NetlifyContactForm';
class AppContact extends React.Component {
  constructor(props) {
    super(props)
    this.talkjsContainer = React.createRef();
  }

  componentDidMount() {    
    Talk.ready.then(() => {
      var me = new Talk.User({
        id: parseInt(Math.random()*500000).toString(),
        name: "Alice",
        email: "demo@talkjs.com",
        photoUrl: "https://demo.talkjs.com/img/alice.jpg",
        welcomeMessage: "Hey there! How are you? :-)",
        role: "booker"
      });
      
     const talkSession = new Talk.Session({
        appId: "tUzMLcrn",
        me: me
      });
      
      var other = new Talk.User({
        id: parseInt(Math.random()*500000).toString(),
        name: "HelpDesk",
        email: "demo@talkjs.com",
        photoUrl: "https://demo.talkjs.com/img/sebastian.jpg",
        welcomeMessage: "Hey, how can We help you?",
        role: "booker"
      });

      var conversation = talkSession.getOrCreateConversation(Talk.oneOnOneId(me, other));
      conversation.setParticipant(me);
      conversation.setParticipant(other);
      
      var inbox = talkSession.createInbox({selected: conversation});
      inbox.mount(this.talkjsContainer.current);
    });
  }

  render() {
    return (
      <div style={{marginTop:'5%'}}>
        <br/>
        <hr/>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={12}>
            <fieldset>Drop us an email</fieldset>
            <NetlifyContactForm/>
          </Col>
          <Col span={12}>
            <fieldset>Lets chat</fieldset>
            <div ref={this.talkjsContainer} className="chatbox-container" 
          style={{marginTop:'7%',marginBottom:'1%',minHeight:'350px',width:'100%',height:'450px'}}></div>
          </Col>
        </Row>
      </div>
    )
  }
}
export default AppContact;
// ReactDOM.render(<AppContact />, document.querySelector("#app"))